'use client';

import type { ReactNode } from 'react';
import type { OutputRenderContext } from '../../tool-config-types';
import { renderThinkingStyleMarkdownResult } from '../shared/generic-result-renderers';
import { stripCodeAnalyzerResultArtifacts } from './strip-code-analyzer-result-artifacts';

export const renderCodeAnalyzerResult = (
  ctx: OutputRenderContext,
): ReactNode => {
  const cleanedContent = stripCodeAnalyzerResultArtifacts(String(ctx.content));

  if (!cleanedContent) {
    return null;
  }

  return renderThinkingStyleMarkdownResult({ ...ctx, content: cleanedContent });
};
